// extracted by mini-css-extract-plugin
module.exports = {"container":"Skills_container__3iQ2o","heading":"Skills_heading__1NWga","aligner":"Skills_aligner__10xmV","title":"Skills_title__Phy2q"};